export default "__VITE_ASSET__gIhXjT$6__"